import React from "react";
import { Route, Routes } from "react-router-dom";
import { ThemeProvider, createUseStyles } from "react-jss";

import FoodListPage from "./components/FoodListPage";
import Login from "./components/Login";
import MathPage from "./components/MathPage";
import MissingLetterPage from "./components/MissingLetterPage";
import Navigation from "./components/Navigation";
import RpgGamePage from "./components/RpgGamePage";
import SpanishVideosPage from "./components/SpanishVideosPage";
import SpellingTestPage from "./components/SpellingTestPage";
import StatusPage from "./components/StatusPage";
import TypingGamePage from "./components/TypingGamePage";
import WordSearchPage from "./components/WordSearchPage";

import "./css/App.css";
import useLocalStorage from "./functions/useLocalStorage";

const theme = {
    background: "white",
};

const useStyles = createUseStyles({
    horizontalLine: {
        "margin-bottom": "2em",
    },
});

function App() {
    const classes = useStyles({ theme });
    const [username, setUsername] = useLocalStorage("USER", "");
    const updateUser = (username) => {
        setUsername(username);
    };
    return (
        <ThemeProvider theme={theme}>
            <header>
                <Navigation username={username} />
            </header>
            <hr className={classes.horizontalLine} />
            <Routes>
                <Route
                    path="/"
                    element={<Login username={username} updateUser={updateUser} />} />
                <Route exact path="/math" element={<MathPage />} />
                <Route exact path="/word-search" element={<WordSearchPage />} />
                <Route
                    path="/missing-letter"
                    element={<MissingLetterPage />}
                />
                <Route
                    path="/spelling-test"
                    element={<SpellingTestPage />}
                />
	        /*
                <Route
                    path="/spanish-videos"
                    element={<SpanishVideosPage />}
                />
		*/
                <Route exact path="/rpg-game" element={<RpgGamePage />} />
                <Route exact path="/food-list" element={<FoodListPage />} />
                <Route exact path="/status" element={<StatusPage />} />
                <Route exact path="/typing" element={<TypingGamePage />} />
            </Routes>
        </ThemeProvider>
    );
}

export default App;
